import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

import { ReactComponent as Icon } from './FeaturedShotsIcon.svg';

/**
 * @function
 * Auto-generated file.
 */
export const FeaturedShotsIcon = React.forwardRef<SVGSVGElement, SvgIconProps>(function FeaturedShotsIcon(props, ref) {
  return (
    <SvgIcon ref={ref} viewBox="0 0 20 20" component={Icon} {...props} />
  );
});
